import { useState } from 'react';

import { StoredValueModel } from '@/tracker/model';

import { ColumnId, GroupBy } from './config';

export type IssueListSettings = { columns: ColumnId[]; groupBy: GroupBy };

const isSettings = (saved: unknown): saved is IssueListSettings =>
  Array.isArray((saved as IssueListSettings | null)?.columns) &&
  typeof (saved as IssueListSettings | null)?.groupBy === 'string';

/**
 * Видимые колонки и группировка списка задач, у каждого экрана свои; помнит этот браузер.
 * Читать в observer-компоненте. Сохраняется только то, что человек поменял: умолчания из кода доходят до остальных
 */
export const useIssueListSettings = ({
  key,
  defaults,
}: {
  key: string;
  defaults: IssueListSettings;
}) => {
  const [model] = useState(
    () =>
      new StoredValueModel({
        key: `tracker.issueList.${key}`,
        fallback: defaults,
        isValid: isSettings,
      }),
  );
  const settings = model.value;

  const toggleColumn = (column: ColumnId) =>
    model.change({
      ...settings,
      columns: settings.columns.includes(column)
        ? settings.columns.filter((id) => id !== column)
        : [...settings.columns, column],
    });

  const setGroupBy = (groupBy: GroupBy) => model.change({ ...settings, groupBy });

  return { settings, toggleColumn, setGroupBy };
};
